module.exports = "/images/arrow-calculator.svg?dcc5cf84f924731299912dbd4b81415c";